export const BUYER_DASHBOARD = {
    DASHBOARD_CONTAINER: "dashboard-container",
    BRANDS_GRID: "brands-grid",
    CONNECTED_BRANDS_CONTAINER: "connected-brands-container",
    CONNECTED_BRANDS_TITLE: "connected-brands-title",
    CONNECTED_BRANDS_LOADING_SPINNER: "inline-loading",
    CONNECTED_BRANDS_EMPTY: "connected-brands-empty",
    CONNECTED_BRANDS_TABS: "connected-brands-tabs",
    CONNECTED_BRANDS_SEARCH: "connected-brands-search",
    CONNECTED_BRANDS_SORT: "connected-brands-sort",
    WELCOME_MESSAGE: "welcome-message",
    DISMISS_ONBOARDING_VIDEO: "dismiss-onboarding-video",
    ONBOARDING_VIDEO: "onboarding-video",
    ONBOARDING_VIDEO_TEXT: "onboarding-video-text",
    QUICK_LINKS: "quick-links-component",
    QUICK_LINKS_LINK: "quick-links-link",
    SETUP_GUIDE_PARENT: "setup-guide-parent",
    SETUP_GUIDE_CHILD: "setup-guide-child",
    SETUP_GUIDE_PARENT_TITLE: "parent-title",
    SETUP_GUIDE_PARENT_DETAILS: "parent-details",
    SETUP_GUIDE_DETAILS_TITLE: "details-title",
    SETUP_GUIDE_DETAILS_CONTENT: "details-content",
    SETUP_GUIDE_DETAILS_BUTTON: "details-button",
    SETUP_GUIDE_DETAILS_LEARN_MORE: "details-learn-more",
    SETUP_GUIDE_ERROR: "setup-guide-error",
    SETUP_GUIDE_DISMISS_MENU: "setup-guide-dismiss-menu",
    SETUP_GUIDE_DISMISS_CTA: "setup-guide-dismiss-cta",
    COMPLETED_TASKS: "completed-tasks",
    COMPLETED_CHECK: "completed-check",
    PROGRESS_BAR: "progress-bar",
    OLD_MARKETPLACE: "old-marketplace",
    LIVE_EVENTS: "live-events",
    MARKETPLACE: "marketplace",
    MARKETPLACE_CATEGORIES: "marketplace-categories",
    MARKETPLACE_EXPAND_BUTTON: "marketplace-expand-button",
    DASHBOARD_LINK: "dashboard",
};
